import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { Stack, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

export interface EsimStatusCardProps {
  esimStatus: string
  tooltipInfo: string
  esimTextColor: string
}
export default function EsimStatusCard({
  esimStatus,
  tooltipInfo,
  esimTextColor
}: EsimStatusCardProps) {
  return (
    <>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '34px',
          p: '40px',
          maxWidth: '215px'
        }}
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{
            fontSize: '24px',
            fontWeight: '700px',
            m: 0
          }}
          text={'eSim Status'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: '10px'
          }}
        >
          The current state of the customer&apos;s eSim. <br />
          Please hover over the info icon for more information
        </TextColorFontBody>

        <Stack sx={{ mt: 3 }}>
          <Typography
            sx={{ fontWeight: '400', color: '#7B8794' }}
            textAlign='left'
          >
            Status
          </Typography>
          <Stack flexDirection={'row'} spacing={1}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '33px',
                pt: '15px',
                color: esimTextColor
              }}
            >
              {esimStatus}
            </Typography>

            <Tooltip
              PopperProps={{
                sx: { maxWidth: '165px', textAlign: 'center' }
              }}
              title={tooltipInfo}
            >
              <InfoIcon fontSize='small' color='disabled' />
            </Tooltip>
          </Stack>
        </Stack>
      </Box>
    </>
  )
}
